import {PayloadAction, createSlice} from '@reduxjs/toolkit';
import {RootState} from './Store';

//  create the thunk
export interface Feedback {
  id?: number;
  question?: string;
  answer?: string;
  feedback?: string;
  messageId?: string;
  is_liked?: boolean;
  is_disliked?: boolean;
  createdByUser?: string;
  createDatetime?: string;
}

const initialState: any = {
  persona: 'sales_analyst',
  chatApi: {},
  summaryInfo: '',
  title: '',
  isDwdAuthenticated: false,
  userData: {
    username: '',
    password: '',
  },
};

// Then, handle actions in your reducers:
export const chatBotSlice = createSlice({
  name: 'chatBotDetails',
  initialState,
  reducers: {
    updatePersona: (state, action: PayloadAction<any>) => {
      state.persona = action.payload;
    },
    updateUserData: (state, action: PayloadAction<any>) => {
      state.userData = action.payload;
    },
    updateAuthentication: (state, action: PayloadAction<any>) => {
      state.isDwdAuthenticated = action.payload;
    },
    updateSummary: (state, action: PayloadAction<any>) => {
      state.summaryInfo = action.payload;
    },
    updateTreeInfo: (state, action: PayloadAction<any>) => {
      state.treeInfo = action.payload;
    },
    updateTitle: (state, action: PayloadAction<any>) => {
      state.title = action.payload;
    },
  },
  extraReducers: (builder) => {},
});
export const {
  updatePersona,
  updateUserData,
  updateAuthentication,
  updateSummary,
  updateTreeInfo,
  updateTitle,
} = chatBotSlice.actions;
export const isDWDPOCAuthenticated = (state: RootState) =>
  state.chatBotDetails.isDwdAuthenticated;

export const getUserData = (state: RootState) => state.chatBotDetails.userData;

export default chatBotSlice.reducer;
